import {IconsProps} from 'types';

export const AddToCartNormalIcon = ({width = 32, height = 32, color = '#F22643'}: IconsProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="34" height="34" rx="17" fill="white" stroke={color} strokeWidth="2" />
      <rect x="1.5" y="1.5" width="33" height="33" rx="16.5" fill={color} stroke="white" />
      <path
        d="M25.815 18C25.815 18.2761 25.7031 18.5261 25.5221 18.7071C25.3411 18.8881 25.0911 19 24.815 19H19.185V24.63C19.185 24.9061 19.0731 25.1561 18.8921 25.3371C18.7111 25.5181 18.4611 25.63 18.185 25.63C17.9089 25.63 17.6589 25.5181 17.4779 25.3371C17.2969 25.1561 17.185 24.9061 17.185 24.63V19H11.555C11.2789 19 11.0289 18.8881 10.8479 18.7071C10.6669 18.5261 10.555 18.2761 10.555 18C10.555 17.7239 10.6669 17.4739 10.8479 17.2929C11.0289 17.1119 11.2789 17 11.555 17H17.185V11.37C17.185 11.0939 17.2969 10.8439 17.4779 10.6629C17.6589 10.4819 17.9089 10.37 18.185 10.37C18.4611 10.37 18.7111 10.4819 18.8921 10.6629C19.0731 10.8439 19.185 11.0939 19.185 11.37V17H24.815C25.0911 17 25.3411 17.1119 25.5221 17.2929C25.7031 17.4739 25.815 17.7239 25.815 18Z"
        fill="white"
      />
    </svg>
  );
};

AddToCartNormalIcon.displayName = 'MakroUI.AddToCartNormalIcon';
